import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { createElement } from 'react';
import { useId } from 'react-id-generator';
import styled from 'styled-components';
import { spacing1x } from '../../styles/spacing.js';
import { ButtonGroupContainer } from '../ButtonGroup/components/ButtonGroupContainer.js';
import { ButtonGroupButtonType } from '../ButtonGroup/types.js';
import { RadioGroupItem } from './RadioGroupItem.js';
import { RadioItemVariant } from './types.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["aria-label", "initialValue", "items", "onChange", "value", "variant", "buttonType"],
  _excluded2 = ["value"];
var Container = styled.div.withConfig({
  displayName: "RadioGroup__Container",
  componentId: "sc-mg92wy-0"
})(["&&{display:flex;flex-direction:column;}&& > div:not(:first-of-type){margin-block-start:calc(", " / 2);}"], spacing1x);
var RadioGroup = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var ariaLabel = props["aria-label"],
    initialValue = props.initialValue,
    items = props.items,
    onChange = props.onChange,
    value = props.value,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? RadioItemVariant.DEFAULT : _props$variant,
    _props$buttonType = props.buttonType,
    buttonType = _props$buttonType === void 0 ? ButtonGroupButtonType.GROUPED : _props$buttonType,
    rest = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(initialValue),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedValue = _React$useState2[0],
    setSelectedValue = _React$useState2[1];
  var groupName = useId(1, "_mntl-radio-group-")[0];
  React.useEffect(function () {
    if (value !== void 0) {
      setSelectedValue(value);
    }
  }, [value]);
  var onRadioChange = function onRadioChange(radioValue) {
    setSelectedValue(radioValue);
    if (onChange) {
      onChange(radioValue);
    }
  };
  var onButtonClick = function onButtonClick(radioValue) {
    setSelectedValue(radioValue);
    if (onChange) {
      onChange(radioValue);
    }
  };
  if (variant === RadioItemVariant.BUTTON) {
    return /*#__PURE__*/jsx(ButtonGroupContainer, {
      ariaLabel: ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : "Radio Group",
      groupName: groupName,
      items: items,
      onClick: onButtonClick,
      ref: ref,
      role: "radiogroup",
      selectedValue: selectedValue,
      type: buttonType
    });
  } else {
    return /*#__PURE__*/jsx(Container, _objectSpread(_objectSpread({
      "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : "Radio Group",
      ref: ref,
      role: "radiogroup"
    }, rest), {}, {
      children: items.map(function (_ref) {
        var radioItemValue = _ref.value,
          radioItemProps = _objectWithoutProperties(_ref, _excluded2);
        return /*#__PURE__*/createElement(RadioGroupItem, _objectSpread(_objectSpread({}, radioItemProps), {}, {
          groupName: groupName,
          key: radioItemValue,
          value: radioItemValue,
          checked: selectedValue === radioItemValue,
          onChange: function onChange() {
            return onRadioChange(radioItemValue);
          }
        }));
      })
    }));
  }
});
RadioGroup.displayName = "RadioGroup";

export { RadioGroup };
